import { bl_fi_deposit_category_RowClass } from '../../dbschema/bl_fi_deposit_category.model';
import { BaseContainerModel } from '../base-container.model';

export class DepositCategoryContainerModel extends BaseContainerModel {
  bl_fi_deposit_category: bl_fi_deposit_category_RowClass = new bl_fi_deposit_category_RowClass();
}
